import { useMemo } from "react";
import { ZustandStore } from "../../../store/zustand-store";
import { sites } from "../../../Navigation/constant";
import { useTranslation } from "react-i18next";
import AIOverviewIcon from "../sidebar/ai black.png";

const SideBarData = () => {
  const { t } = useTranslation();
  const lang = localStorage.getItem("APP_LANG");
  const { isAdminPerformAction } = ZustandStore((state) => state);

  const adminNavItem = useMemo(() => {
    return [
      {
        id: "1",
        name: "Dashboard",
        url: "../admin",
        path: ["/admin"],
      },
      {
        id: "2",
        name: "Users",
        url: "#",
        path: ["/admin/users", "/map-tracker"],
        sub_list: [
          {
            name: "Users List",
            url: "users",
            path: ["/admin/users"],
          },
          {
            name: "User Answer",
            url: "user/question/answer",
            path: ["/admin/user/question/answer"],
          },
          {
            name: "User Project",
            url: "user/project",
            path: ["/admin/user/project"],
          },
          {
            name: "User Services",
            url: "user/services",
            path: ["/admin/user/services"],
          },
        ],
      },
      {
        id: "3",
        name: "Refresh Data",
        url: "#",
        path: [
          "/admin/refresh/site-audit",
          "/admin/refresh/site-overview",
          "/admin/refresh/keyword",
        ],
        sub_list: [
          {
            name: "Site Overview",
            url: "refresh/site-overview",
            path: ["/admin/refresh/site-overview"],
          },
          {
            name: "Backlink",
            url: "refresh/backlink",
            path: ["/admin/refresh/backlink"],
          },
        ],
      },
      {
        id: "4",
        url: "adminkeywords",
        name: "Keywords",
        path: ["/admin/adminkeywords"],
      },
      {
        id: "5",
        name: "Plans",
        url: "#",
        path: ["/admin/plans", "/admin/addon-plans", "/admin/plan/cancel"],
        isAction: isAdminPerformAction?.isPerformAction,
        sub_list: [
          {
            name: "Plans List",
            url: "plans",
            path: ["/admin/plans"],
          },
          {
            name: "Plan Addon",
            url: "addon-plans",
            path: ["/admin/addon-plans"],
          },
          {
            name: "Cancel Plan",
            url: "plan/cancel",
            path: ["/admin/plan/cancel"],
          },
        ],
      },
      {
        id: "6",
        url: "codes",
        path: ["/admin/codes"],
        name: "Codes",
        isAction: isAdminPerformAction?.isPerformAction,
      },
      {
        id: "7",
        url: "mail",
        name: "Mail",
        path: ["/admin/mail"],
        isAction: isAdminPerformAction?.isPerformAction,
      },
      {
        id: "8",
        url: "invite-mail",
        path: ["/admin/invite-mail"],
        name: "Invite",

        isAction: isAdminPerformAction?.isPerformAction,
      },
      {
        id: "9",
        url: "feedback",
        name: "Feedback",
        path: ["/admin/feedback"],
        isAction: isAdminPerformAction?.isPerformAction,
      },
      {
        id: "10",
        url: "free-tool-usage",
        name: "Tool Usage",
        path: [
          "/admin/free-tool-usage",
          "/admin/free-tool-rank-tracker",
          "/admin/free-tool-page-vital",
          "/admin/free-tool-backlink",
        ],
        isAction: isAdminPerformAction?.isPerformAction,
      },
      {
        id: "11",
        name: "Affilates",
        url: "#",
        path: [
          "/admin/affiliate-list",
          "/admin/affiliate-reward",
          "/admin/affiliate-withdrawal-request",
        ],
        isAction: isAdminPerformAction?.isPerformAction,
        sub_list: [
          {
            name: "Affilates List",
            url: "affiliate-list",
            path: ["/admin/affiliate-list"],
          },
          {
            name: "Rewards",
            url: "affiliate-reward",
            path: ["/admin/affiliate-reward"],
          },
          {
            name: "Withdrawal Request",
            url: "affiliate-withdrawal-request",
            path: ["/admin/affiliate-withdrawal-request"],
          },
        ],
      },
      {
        id: "12",
        url: "digital-agency",
        path: ["/admin/digital-agency", "/admin/details", "/admin/reviews"],
        name: "Digital Agency",
        isAction: isAdminPerformAction?.isPerformAction,
      },
      {
        id: "13",
        url: "product/sites",
        path: ["/admin/product/sites"],
        name: "Buy Guest Posts",
        isAction: isAdminPerformAction?.isPerformAction,
      },
    ];
  }, [isAdminPerformAction, lang]);

  const userNavItem = useMemo(() => {
    return [
      {
        url: "/projects",
        path: ["/projects"],
        name: t("sidebar.user.projects.title"),
      },
      {
        url: "/dashboard",
        path: [
          "/dashboard",
          "/addpr",
          "/addpr/addcountry",
          "/addpr/addcompetitors",
          "/addpr/addkeyword",
        ],
        name: t("sidebar.user.dashboard.title"),
      },
      {
        name: t("sidebar.user.rank_tracking.title"),
        url: "#",
        path: ["/rank-tracker", "/map-tracker"],
        sub_list: [
          {
            name: t("sidebar.user.rank_tracking.submenu.rank_tracker"),
            url: "/rank-tracker",
            path: ["/rank-tracker"],
          },
          {
            name: t("sidebar.user.rank_tracking.submenu.map_tracker"),
            url: "/map-tracker",
            path: ["/map-tracker"],
          },
        ],
      },
      // {
      //   name: "LLM Tracker",
      //   url: "/llm-tracker",
      //   path: ["/llm-tracker"],
      // },
      {
        name: t("sidebar.user.rank_tracking.submenu.ai_tracker"),
        url: "/ai-tracker",
        path: ["/ai-tracker"],
        icon: AIOverviewIcon,
      },
      // {
      //   name: t("sidebar.user.opportunity.title"),
      //   url: "/opportunities",
      //   path: ["/opportunities"],
      // },
      {
        url: "site-audit",
        path: ["/site-audit"],
        name: t("sidebar.user.site_audit.title"),
      },
      {
        name: t("sidebar.user.keyword_research.title"),
        url: "#",
        path: [
          "/view-lists",
          "/keyword-research/ideas",
          "/keyword-research/overview",
          "/keyword-research/variations",
        ],
        sub_list: [
          {
            name: t("sidebar.user.keyword_research.submenu.keyword_overview"),
            url: "/keyword-research/overview",
            path: ["/keyword-research/overview"],
          },
          {
            name: t("sidebar.user.keyword_research.submenu.keyword_variations"),
            url: "/keyword-research/variations",
            path: ["/keyword-research/variations"],
          },
          {
            name: t("sidebar.user.keyword_research.submenu.keyword_ideas"),
            url: "/keyword-research/ideas",
            path: ["/keyword-research/ideas"],
          },
          {
            name: t("sidebar.user.keyword_research.submenu.keyword_list"),
            url: "/view-lists?list_type=keyword",
            path: ["/view-lists"],
          },
        ],
      },
      {
        name: t("sidebar.user.competitive_research.title"),
        url: "#",
        path: [
          "/site-overview",
          "/site-overview/aio-keywords",
          "/site-overview/organic-keywords",
        ],
        sub_list: [
          {
            name: t("competitive_research.overview_title"),
            url: "/site-overview",
            path: ["/site-overview"],
          },
          {
            name: t("site_audit.dashboard_page.box.organic_keyword.title"),
            url: "/site-overview/organic-keywords",
            path: ["/site-overview/organic-keywords"],
          },
          {
            name: t("competitive_research.aio.title"),
            url: "/site-overview/aio-keywords",
            path: ["/site-overview/aio-keywords"],
            icon: AIOverviewIcon,
          },
        ],
      },
      {
        name: t("sidebar.user.backlinks.title"),
        url: "#",
        path: ["/backlinks", "/backlink-gap"],
        sub_list: [
          {
            name: t("sidebar.user.backlinks.submenu.backlink_analysis"),
            url: "/backlinks",
            path: ["/backlinks"],
          },
          {
            name: t("sidebar.user.backlinks.submenu.backlinks_gap"),
            url: "/backlink-gap",
            path: ["/backlink-gap"],
          },
        ],
      },
      {
        name: t("sidebar.user.buy_guest_post.title"),
        url: sites,
        path: [sites],
        openInNewTab: true,
      },
      {
        name: t("sidebar.user.ai_writers.title"),
        url: "/ai/tools",
        path: ["/ai/tools", "/ai/content/projects", "/ai/content-writer"],
        icon: AIOverviewIcon,
      },
      // {
      //   name: "Report Builder",
      //   url: "/reportbuilder",
      //   path: ["/reportbuilder"],
      // },
      {
        name: t("sidebar.user.activity.title"),
        url: "/activity",
        path: ["/activity"],
      },
    ];
  }, [isAdminPerformAction, lang]);

  const adsyNavItem = useMemo(() => {
    return [
      {
        id: "2",
        name: "Websites",
        url: sites,
        path: [sites],
      },
    ];
  }, [lang]);

  return {
    adminNavItem,
    userNavItem,
    adsyNavItem,
  };
};

export default SideBarData;
